// extracted by mini-css-extract-plugin
export default {"countStyle":"style_countStyle__Ju65F"};